import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';

function Header() {
  return (
    <AppBar position="static" elevation={0} sx={{ backgroundColor: 'secondary.main' }}>
      <Toolbar>
        <Box display="flex" alignItems="center">
            <img src="/logo192.png" alt="Prim & Prompter logo" style={{ height: '40px', marginRight: '12px' }} />
            <Typography variant="h1" sx={{
                fontFamily: '"Grand Hotel", cursive',
                fontWeight: 400,
                fontSize: '2.2rem',
                color: 'white',
                textShadow: '1px 1px 3px rgba(0,0,0,0.2)'
            }}>
                Prim & Prompter
            </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;